var _process$env$OV_NS_EN = process.env.OV_NS_ENDPOINT,
    OV_NS_ENDPOINT = _process$env$OV_NS_EN === void 0 ? '//ns.outdoorvoices.com/api/v1/' : _process$env$OV_NS_EN;
export { OV_NS_ENDPOINT };
var _process$env$OV_CDN = process.env.OV_CDN,
    OV_CDN = _process$env$OV_CDN === void 0 ? 'https://cdn.outdoorvoices.com/' : _process$env$OV_CDN;
export { OV_CDN };
var _process$env$OV_EMS_C = process.env.OV_EMS_CDN,
    OV_EMS_CDN = _process$env$OV_EMS_C === void 0 ? 'https://cdn.ov.app/' : _process$env$OV_EMS_C;
export { OV_EMS_CDN };
var _process$env$OV_GRAPH = process.env.OV_GRAPHQL_URL,
    OV_GRAPHQL_URL = _process$env$OV_GRAPH === void 0 ? 'http://api.ems.com:8000/graphql' : _process$env$OV_GRAPH;
export { OV_GRAPHQL_URL };
var _process$env$OV_EVENT = process.env.OV_EVENTS_GRAPHQL_URL,
    OV_EVENTS_GRAPHQL_URL = _process$env$OV_EVENT === void 0 ? 'http://events.ov.com:8001/graphql' : _process$env$OV_EVENT;
export { OV_EVENTS_GRAPHQL_URL };
var _process$env$OV_ID_UR = process.env.OV_ID_URL,
    OV_ID_URL = _process$env$OV_ID_UR === void 0 ? 'http://accounts.ov.com:5000/' : _process$env$OV_ID_UR;
export { OV_ID_URL };
var _process$env$OV_IMG_S = process.env.OV_IMG_SERVICE_URL,
    OV_IMG_SERVICE_URL = _process$env$OV_IMG_S === void 0 ? 'https://images.ov.app/' : _process$env$OV_IMG_S;
export { OV_IMG_SERVICE_URL };
var _process$env$OV_S3_BU = process.env.OV_S3_BUCKET,
    OV_S3_BUCKET = _process$env$OV_S3_BU === void 0 ? 'ov-ems-stage' : _process$env$OV_S3_BU;
export { OV_S3_BUCKET };
var _process$env$OV_VERSI = process.env.OV_VERSION,
    OV_VERSION = _process$env$OV_VERSI === void 0 ? '2.0.0' : _process$env$OV_VERSI;
export { OV_VERSION };
var _process$env$OV_SUBSC = process.env.OV_SUBSCRIBE_URL,
    OV_SUBSCRIBE_URL = _process$env$OV_SUBSC === void 0 ? 'https://subscribe.ov.app/' : _process$env$OV_SUBSC;
export { OV_SUBSCRIBE_URL };
var _process$env$OV_SHOPI = process.env.OV_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    OV_SHOPIFY_STOREFRONT_ACCESS_TOKEN = _process$env$OV_SHOPI === void 0 ? '49647d3fcfcc88c237e742815b057cdf' : _process$env$OV_SHOPI;
export { OV_SHOPIFY_STOREFRONT_ACCESS_TOKEN };
var _process$env$OV_SHOPI2 = process.env.OV_SHOPIFY_STORE,
    OV_SHOPIFY_STORE = _process$env$OV_SHOPI2 === void 0 ? 'outdoor-voices' : _process$env$OV_SHOPI2;
export { OV_SHOPIFY_STORE };